export default {
  'en-US': {
    eCommerceStage: {
      GettingStarted: 'Just getting started - no orders yet',
      AlreadySelling: 'I\'m already selling products online'
    }
  }
}
